import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaHeart, FaEye, FaClock } from "react-icons/fa";
import SignupModal from './SignupModal';
import { FaTrash } from "react-icons/fa";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { Translator } from './translator';

const BASE = "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com";

const TourPreview = () => {
  const { tourID } = useParams();
  const navigate = useNavigate();
  const [isNextSource, setIsNextSource] = useState(false);
  const [tourData, setTourData] = useState(null);
  const [comments, setComments] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isLiked, setIsLiked] = useState(false); 
  const [commentText, setCommentText] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedText, setEditedText] = useState("");
  const { translateText, lang } = Translator();
  const [ttsAudioUrl, setTtsAudioUrl] = useState(null);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const isFree = Number(tourData?.price) === 0;
  const [user, setUser] = useState(null);
 
  const baseText = {
    text1: "Ti invitiamo ad effettuare prima l'accesso per aggiungere il prodotto al carrello.",
    text2: "Impossibile salvare nel carrello.",
    text3: "Si è verificato un errore durante l'aggiunta al carrello.",
    text4: "Teche Tour",
    text5: "Descrizione non disponibile",
    text6: "Non specificata",
    
    text8: "Errore dal server: ",
    text9: "Errore durante l'invio del commento:",
    text10: "Non puoi più eliminare questo commento. L'eliminazione è consentita solo entro 24 ore.",
    text11: "Errore durante l'eliminazione del commento:",
    text12: "Non puoi più modificare questo commento. Le modifiche sono consentite solo entro 24 ore.",
    text13: "Errore durante la modifica del commento:",
    text14: "Caricamento...",
    
    text15: "giorno consigliato",
    text16: "giorni consigliati",
    textic: "Include:",
    text17: "Gallerie fotografica",
    text18: "Posizione luoghi d’interesse",
    text19: "Descrizioni storiche",
    text20: "Video",
    text21: "Esperienze immersive in AR",
    text22: "Esperienze immersive in VR",
    text23: "Esperienze multimediali",
    text24: "Aggiungi al carrello",
    text25: "Acquista",
    text26: "commento",
    text27: "commenti",
    text28: "Salva",
    text29: "Annulla",
    text30: "Modifica",
    text31: "Sei sicuro di voler eliminare questo commento?",
    text32: "Elimina commento",
    text33: "Scrivi un commento",
    text34: "Invia commento",

    textfree: "Goditi il tour gratuito",
    textfree2: "GRATUITO",
    
    texterror1: "Errore durante la generazione del pagamento.",

    }

  const [translatedText, setTranslatedText] = useState(baseText);
  useEffect(() => {
    const translateAll = async () => {
      const entries = Object.entries(baseText);
      const translatedEntries = await Promise.all(
        entries.map(async ([key, value]) => [key, await translateText(value)])
      );
      setTranslatedText(Object.fromEntries(translatedEntries));
    };
  
    translateAll();
  }, [lang]);


const handleToggleLike = async () => {
  if (!user || !user.email) {
    setShowModal(true);
    return;
  }

  try {
    const res = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/addRemoveLikeToTour`, {
      params: { tourID, email: user.email }
    });

    if (typeof res.data === "number") {
      setTourData(prev => ({
        ...prev,
        likes: prev.likes + (res.data === 1 ? 1 : -1)
      }));
      setIsLiked(res.data === 1);
    }
  } catch (err) {
    console.error("Errore nel like:", err);
  }
};


const handleAddToCart = async () => {
  if (!user || !user.email) {
    setShowModal(true);
    return;
  }

  try {
    const payload = {
      email: user.email,
      tourID: parseInt(tourID),
    };

    //console.log("Sending payload:", payload);
    const res = await axios.post("https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/saveToCart", payload);
    //console.log("Response from backend:", res.data);

    if (res.data.status === "success") {
      window.dispatchEvent(new Event("showCartPopup"));
    } else {
      alert(translatedText.text2);
      //console.error(res.data);
    }
  } catch (err) {
    //console.error("Error adding to cart:", err.response?.data || err.message);
    alert(translatedText.text3);
  }
};




useEffect(() => {
  if (user?.userID) {
    axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getUserID?email=${user.email}`)
      .then((res) => {
        const data = res.data;
        if (Array.isArray(data) && data.length > 0) {
          const fullUser = data[0];
          //console.log("User1 Full Info:", fullUser);
        }
      })
      .catch(err => console.warn("Failed1 to load full user info", err));
  }
}, [user]);




useEffect(() => {
  const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
  }, []);


useEffect(() => {
  const onLogin = (e) => {
     const u = e?.detail || JSON.parse(localStorage.getItem("user"));
     setUser(u || null);
   };
   window.addEventListener("auth:login", onLogin);
   return () => window.removeEventListener("auth:login", onLogin);
 }, []);




  useEffect(() => {
    const fetchTour = async () => {
      try {
        const res = await axios.get(`${BASE}/AntiPrimaTours?nodeID=${tourID}&lang=${lang}`);
        const tour = res.data?.tour;
        setIsNextSource(Boolean(res.data?.isNext));
        
        if (tour) {
                const entries = Object.entries(tour);

      const hasAnyAR = entries.some(([key, value]) => {
  const match = key.includes("tappaAR") && value === "YES";
  if (match) console.log("AR detected on key:", key, "value:", value);
  return match;
});

const hasAnyVR = entries.some(([key, value]) => {
  const match = key.includes("tappaVR") && value === "YES";
  if (match) console.log("VR detected on key:", key, "value:", value);
  return match;
});

      //console.log("👉 hasAR:", hasAnyAR, "| hasVR:", hasAnyVR);


          setTourData({
          name: tour.Name_it || translatedText.text4,
          Subheading: tour.Subheading_it,
          description: tour.Description_it || translatedText.text5,
          duration: tour.duration || "0",
          likes: tour.likes || 0,
          views: tour.views || 526,
          image: tour.Image ? `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${tour.Image}` : null,
          audio: tour.TourAudio_it || null,
          area: tour.Area || translatedText.text6,
          price: tour.FullPrice,
          hasAR: entries.some(([key, value]) => key.includes("tappaAR") && value === "YES"),
          hasVR: entries.some(([key, value]) => key.includes("tappaVR") && value === "YES"),
        });
        }
      } catch (err) {
        console.error("Error retrieving tour:", err);
      }
    };

    const fetchComments = async () => {
      try {
        const res = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTourComments?tourID=${tourID}`);
        if (Array.isArray(res.data)) {
          setComments(res.data);
        }
      } catch (err) {
        console.error("Error fetching comments:", err);
      }
    };

    fetchTour();
    fetchComments();
  }, [tourID, lang]);

  // -----------------------------
  //  Comment Handling
  // -----------------------------
  const handleCommentSubmit = async () => {
    //const user = JSON.parse(localStorage.getItem("user"));
    if (!user || !user.email) {
      setShowModal(true); // force login
      return;
    }
    const payload = {
      email: user.email,
      tourID: parseInt(tourID),  // To ensure it's a number
      text: commentText.trim()
    };
  
    //console.log("Submit comment:", payload);

    try {
      const res = await axios.post("https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/addTourComment", payload);
      //console.log("Backend response:", res.data);
  
      if (res.data.error) {
        alert(translatedText.text8 + res.data.error);
        return;
      }
  
      setCommentText("");
      // Refresh comments
      const refreshed = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTourComments?tourID=${tourID}`);
      if (Array.isArray(refreshed.data)) {
        setComments(refreshed.data);
      }
    } catch (err) {
      //console.error(translatedText.text9, err.response?.data || err.message);
      alert(translatedText.text9 + (err.response?.data?.error || err.message));
    }
  };
  

  // -----------------------------
  //  Delete Comments
  // -----------------------------
  const handleDeleteComment = async (text) => {
    if (!user || !user.email) return;
  
    try {
      const response = await axios.post("https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/deleteTourComment", {
        email: user.email,
        text: text
      }, {
        headers: {
          "Content-Type": "application/json"
        }
      });

      // If comment is one day old, don't edit
      if (response.data === 0) {
        alert("Non puoi più eliminare questo commento. L'eliminazione è consentita solo entro 24 ore.");
        return;
      }
  
      // Refresh comments if deletion succeeded
      const res = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTourComments?tourID=${tourID}`);
      if (Array.isArray(res.data)) setComments(res.data);
    } catch (err) {
      //console.error(translatedText.text11, err);
      alert(translatedText.text11 + (err.response?.data?.error || err.message));
    }
  };
  


  
  // -----------------------------
  //  Edit Comments
  // -----------------------------
  const handleEditComment = async () => {
    if (!user || !user.email || editingIndex === null) return;
  
    try {
      const response = await axios.post("https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/editTourComment", {
        email: user.email,
        oldText: comments[editingIndex].text,
        newText: editedText.trim(),
      }, {
        headers: { "Content-Type": "application/json" }
      });

      // If comment is one day old, don't edit
      if (response.data === 0) {
        alert(translateText.text12);
        return;
      }

      // if less than 24 hours, edit
      setEditingIndex(null);
      setEditedText("");
  
      // Refresh comments
      const res = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTourComments?tourID=${tourID}`);
      if (Array.isArray(res.data)) setComments(res.data);
    } catch (err) {
      //console.error(translatedText.text13, err);
      alert(translatedText.text13 + (err.response?.data?.error || err.message));
    }
  };
  

  











  // -----------------------------
  //  Fetch Polly TTS
  // -----------------------------
  const speakWithPolly = async (text) => {
    try {
      setIsSpeaking(true);
      setTtsAudioUrl(null); // reset before request
  
      const res = await fetch(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/speak1?text=${encodeURIComponent(text)}&lang=${lang}`);
      const audioUrl = await res.text();
  
      setTtsAudioUrl(audioUrl);
    } catch (err) {
      //console.error("TTS failed:", err);
      setTtsAudioUrl(null);
    } finally {
      setIsSpeaking(false);
    }
  };


  useEffect(() => {
    setTtsAudioUrl(null);  // Reset audio on language change
  }, [lang]);





  const fetchPollyAudio = async (text) => {
    try {
      setTtsAudioUrl(null); // reset
      const res = await fetch(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/speak?text=${encodeURIComponent(text)}&lang=${lang}`);
      const audioUrl = await res.text();
      setTtsAudioUrl(audioUrl); // audio will be loaded
    } catch (err) {
      //console.error("TTS fetch failed:", err);
      setTtsAudioUrl(null);
    }
  };

  
  // ------------------------------------
  //  Translate Tour Description for TTS
  // ------------------------------------
  useEffect(() => {
  const speakTranslatedDescription = async () => {
    if (!tourData || !tourData.description) return;

    if (tourData.audio) {
      setTtsAudioUrl(null);
      return;
    }

    try {
      const translated = await translateText(tourData.description);
      fetchPollyAudio(translated);
    } catch (err) {
      console.error("Error during Polly translation or fetch:", err);
    }
  };

  speakTranslatedDescription();
}, [lang, tourData?.description, tourData?.audio]);


  

  



  const hasRendered = useRef(false);

useEffect(() => {
  if (hasRendered.current) {
    if (tourData?.description) {
      fetchPollyAudio(tourData.description);
    }
  } else {
    hasRendered.current = true;
  }
}, [lang]);
















  if (!tourData) {
    return <div className="text-center py-10 text-black">{translatedText.text14}</div>;
  }

  return (
    <>
      {showModal && <SignupModal onClose={() => setShowModal(false)} />}
    <div className="relative min-h-screen w-full overflow-visible">
  <div
    className="absolute inset-0 z-0"
    style={{
      backgroundImage: `
        linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
        url(${tourData.image})
      `,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    }}
  />

  <div className="relative z-0 max-w-5xl mx-auto px-4 py-8 bg-opacity-90 shadow-lg rounded-xl text-white overflow-visible">



      <div className="mb-4 text-center">
    <h1 className="text-4xl font-bold text-white mb-2 no-underline border-none">{tourData.name}</h1>
    <h3 className="text-2xl text-white no-underline border-none">{tourData.Subheading}</h3>
  </div>

      



      <div className="w-full max-w-4xl mx-auto px-4">
        <div className="flex flex-wrap justify-between items-center text-sm text-white py-2 border-t border-b border-gray-200">
          <div className="flex items-center gap-2">
            <span className="text-red-600">📌</span>
            <span>{tourData.area}</span>
          </div>
          
          {/*
          <div className="flex items-center gap-2">
            <span className="text-white">🕒</span>
            <span>   {tourData.duration} {Number(tourData.duration) === 1 ? translatedText.text15 : translatedText.text16}      </span>
          </div>
          */}

          {/*
          <div className="flex items-center gap-2">
            <button
              onClick={handleToggleLike}
              className={`text-sm bg-transparent flex items-center gap-1 ${isLiked ? "text-red-500" : "text-white"}`}
              title={isLiked ? "Rimuovi Like" : "Metti Like"}
            >
              <FaHeart />
              <span>{tourData.likes}</span>
            </button>
          </div>
*/}



          <div className="flex items-center gap-2">
            <span className="text-blue-500">👁️</span>
            <span>{tourData.views}</span>
          </div>
        </div>
      </div>

      <p className="text-white leading-relaxed mt-10 mb-6">{tourData.description}</p>





  <div
    className={`mx-auto w-4/5 max-w-[60%] min-w-[40%]`}
  >
    <AudioPlayer
      src={
        tourData.audio
          ? `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${tourData.audio}` : 
           ttsAudioUrl
      }
      autoPlay={false}
      showSkipControls={false}
      showJumpControls={false}
      customAdditionalControls={[]}
      customVolumeControls={["volume"]}
      layout="horizontal-reverse"
      // Custom play button color via style
      style={{
        '--rhap_play-button-color': '#324B8E',
        '--rhap_play-button': '#324B8E'
      }}
    />
    <style>
      {`
        .rhap_play-pause-button {
          color: #324B8E !important;
        }
        .rhap_play-pause-button svg {
          fill: #324B8E !important;
        }
      `}
    </style>
  </div>





<div className="flex justify-between items-center gap-8 flex-wrap mt-16 mb-6">
  {/* Left side: Include List */}
  <div>
    <h3 className="text-white mb-2">{translatedText.textic}</h3>
    <ul className="list-disc pl-5 text-white leading-none">
      <li>{translatedText.text17}</li>
      <li>{translatedText.text18}</li>
      <li>{translatedText.text19}</li>
      <li>{translatedText.text20}</li>
      {tourData.hasAR && <li>{translatedText.text21}</li>}
      {tourData.hasVR && <li>{translatedText.text22}</li>}
      {!tourData.hasAR && !tourData.hasVR && <li>{translatedText.text23}</li>}
    </ul>
  </div>

  {/* Right side: Price + Buttons */}
  <div className="flex flex-col items-end ml-auto text-right min-h-[160px] justify-end gap-2">
    <span className="text-2xl text-white font-bold" style={{ fontFamily: 'Montserrat, sans-serif' }}>
      {isFree ? translatedText.textfree2 : `🏷️${parseFloat(tourData.price).toFixed(2)}€`}
    </span>










{!isNextSource && (
isFree ? (
    <button
    onClick={() => navigate(`/tour/${tourID}`)}
    className="px-4 py-1 text-sm md:text-base bg-[#49B15D] border-[#49B15D] rounded-full transition duration-200"
  >
  {translatedText.textfree}
  </button>
) : (

    <div className="flex gap-2">
  <button
    onClick={handleAddToCart}
    className="px-4 py-1 text-sm md:text-base bg-white text-[#49B15D] border-[#49B15D] rounded-full transition duration-200 whitespace-nowrap"
  >
    {translatedText.text24}
  </button>
  <button
    onClick={async () => {
      if (!user || !user.email) {
        setShowModal(true);
        return;
      }

      try {
        // Step 1: Create PaymentIntent for the selected tour
        const res = await axios.post(
          "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/createPaymentIntent",
          { amount: tourData.price }
        );

        const clientSecret = res.data?.clientSecret;
        if (!clientSecret) {
          alert("Errore nella creazione del pagamento.");
          return;
        }

        // Step 2: Navigate to checkout and send only this tour
        navigate('/checkout', {
          state: {
            clientSecret,
            tourData,
            email: user.email,
          }
        });
      } catch (err) {
        alert(translatedText.texterror1);
      }
    }}
    className="px-4 py-1 text-sm md:text-base bg-[#49B15D] border-[#49B15D] rounded-full transition duration-200"
  >
    {translatedText.text25}
  </button>
</div>
)
)}

















  </div>
</div>









      <div className="mt-10">
        {/* Like (left)  |  Comment count (right) */}
        <div className="mb-2 flex items-center justify-between">
          {/* LEFT: Like button */}
          <button
            onClick={handleToggleLike}
            className={`text-sm bg-transparent flex items-center gap-2 ${
              isLiked ? "text-red-500" : "text-white"
            }`}
            title={isLiked ? "Rimuovi Like" : "Metti Like"}
            aria-label={isLiked ? "Rimuovi Like" : "Metti Like"}
          >
            <FaHeart />
            <span className="font-semibold">{tourData.likes}</span>
          </button>

          {/* RIGHT: Comment counter */}
          <h2 className="text-xl font-semibold text-white">
            {comments.length}{" "}
            {Number(comments.length) <= 1 ? translatedText.text26 : translatedText.text27}
          </h2>
        </div>






        
        
        
        
        <div className="space-y-4 mt-2">
          {[...comments]
            .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
            .map((c, index) => {
          const isOwner = user && user.email && c.email && c.email.trim().toLowerCase() === user.email.trim().toLowerCase();


//console.log("🧪 Comparing if author:", c.email, "is same user", user?.email);
  return (
    <div key={index} className="border p-3 rounded bg-[#ffffff] text-white">
      <div className="flex justify-between items-start">
        {/* Left: User info + comment text */}
        <div>
          <div className="font-semibold text-blue-700">{c.author}</div>
          
          










          {editingIndex === index ? (
  <div className="mt-1">
    <textarea
      className="w-[300%] max-w-none border p-2 rounded text-black"
      value={editedText}
      onChange={(e) => setEditedText(e.target.value)}
    />
    <div className="flex gap-2 mt-1">
      <button
        className="px-3 py-1 bg-green-600 text-white rounded"
        onClick={handleEditComment}
        disabled={!editedText.trim()}
      >
        {translatedText.text28}
      </button>
      <button
        className="px-3 py-1 bg-white text-[#49B15D] rounded"
        onClick={() => {
          setEditingIndex(null);
          setEditedText("");
        }}
      >
        {translatedText.text29}
      </button>
    </div>
  </div>
) : (
  <p className="text-black mt-1">{c.text}</p>
)}










        </div>

        {/* Right: Time + actions */}
        <div className="flex flex-col items-end text-right">
          <span className="text-sm text-black whitespace-nowrap">
            {new Date(c.timestamp).toLocaleString("it-IT", {
              dateStyle: "medium",
              timeStyle: "short"
            })}
          </span>
          
            <div className="flex items-center gap-2 mt-1">
              {/* Edit icon */}
              {isOwner && (
              <button
                className="bg-transparent text-black hover:text-white p-1 rounded"
                title={translatedText.text30}
                onClick={() => {
                  setEditingIndex(index);
                  setEditedText(c.text);
                }}
              >
                ✏️
              </button>
              )}

              {/* Delete icon */}
              {isOwner && (
              <button
                onClick={() => {
                  const confirmDelete = window.confirm(translatedText.text31);
                  if (confirmDelete) {
                    handleDeleteComment(c.text);
                  }
                }}
                className="bg-transparent text-red-500 hover:text-red-700 p-1 rounded"
                title={translatedText.text32}
              >
                <FaTrash className="w-4 h-4" />
              </button>
              )}
            </div>

        </div>
      </div>
    </div>

  );
})}
</div>










        {!localStorage.getItem("user") && (
        <div
          className="flex items-center gap-2 cursor-pointer text-[#49B15D]"
          onClick={() => setShowModal(true)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 h-5 text-white"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M18 13a1 1 0 01-1 1H7l-4 4V4a1 1 0 011-1h13a1 1 0 011 1v9z" />
          </svg>
          <span>{translatedText.text33}</span>
        </div>
      )}
      </div>





      {JSON.parse(localStorage.getItem("user")) && (
  <div className="mt-6 rounded-2xl px-4 py-2 flex items-center justify-between"
    style={{ width: '105%', transform: 'translateX(-2.5%)' }}>
    <input
      type="text"
      className="flex-grow bg-[transparent] outline-none text-base text-white placeholder-gray-500 px-3 py-2 rounded-xl border border-gray-400"
      placeholder={translatedText.text33}
      value={commentText}
      onChange={(e) => setCommentText(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && commentText.trim()) {
          e.preventDefault();
          handleCommentSubmit();
        }
      }}
    />

    <button
      onClick={handleCommentSubmit}
      disabled={!commentText.trim()}
      className={`ml-2 w-8 h-8 rounded-full flex items-center justify-center bg-[#324B8E] transition ${
      !commentText.trim() ? "opacity-50 cursor-not-allowed" : ""
    }`}
      title={translatedText.text34}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-4 h-4"
        viewBox="0 0 24 24"
        fill="white"
      >
        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
      </svg>
    </button>
  </div>
)}













    </div>
    </div>






    </>

  );
};

export default TourPreview;
